import {
  IsBoolean,
  IsDateString,
  IsDefined,
  IsInstance,
  IsOptional,
  IsString,
} from 'class-validator';
import { ActivityFeedUserDataDto } from './activity-feed-user.dto';
import {
  IActivityFeedPost,
  IActivityFeedPostActor,
  IActivityFeedPostData,
  IActivityFeedPostOptions,
} from '../../interface/activity-feed';

export class ActivityFeedPostDataDto implements IActivityFeedPostData {
  @IsOptional()
  @IsString()
  image?: string;

  @IsDefined()
  @IsString()
  text: string;

  @IsOptional()
  @IsDateString()
  edited_at?: string;
}

export class ActivityFeedPostActorDto implements IActivityFeedPostActor {
  @IsDefined()
  @IsString()
  id: string;

  @IsDefined()
  @IsDateString()
  created_at: string;

  @IsDefined()
  @IsDateString()
  updated_at: string;

  @IsDefined()
  @IsInstance(ActivityFeedUserDataDto)
  data: ActivityFeedUserDataDto;
}

export class ActivityFeedPostOptionsDto implements IActivityFeedPostOptions {
  @IsDefined()
  @IsBoolean()
  edit: boolean;

  @IsDefined()
  @IsBoolean()
  delete: boolean;
}

export class ActivityFeedPostDto implements IActivityFeedPost {
  @IsDefined()
  @IsString()
  verb: string;

  @IsDefined()
  @IsString()
  time: string;

  @IsDefined()
  @IsString()
  target: string;

  @IsDefined()
  @IsString()
  origin: string;

  @IsDefined()
  @IsString()
  object: string;

  @IsDefined()
  @IsString()
  id: string;

  @IsDefined()
  @IsString()
  foreign_id: string;

  @IsDefined()
  @IsInstance(ActivityFeedPostDataDto)
  post: ActivityFeedPostDataDto;

  @IsDefined()
  @IsInstance(ActivityFeedPostActorDto)
  actor: ActivityFeedPostActorDto;

  // Virtual property calculated in the service based on user permissions
  @IsOptional()
  @IsInstance(ActivityFeedPostOptionsDto)
  options?: ActivityFeedPostOptionsDto;
}
